/**
 * AGB (Allgemeine Geschäftsbedingungen) page generator
 * Swiss-law template for KMU
 */
import { esc } from '@/utils/escape';

export function generateAgbHTML(settings: any): string {
  const legal = settings.companyLegal || {};
  const agb = settings.agb || {};
  const gerichtsstand = agb.gerichtsstand || 'Bern';
  const zahlungsfrist = agb.zahlungsfrist || '30 Tage';

  return `<!DOCTYPE html>
<html lang="de"${settings.darkMode ? ' class="dark"' : ''}>
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>AGB \u2013 ${esc(settings.siteName)}</title>
  <link rel="stylesheet" href="css/tokens.css">
  <link rel="stylesheet" href="css/components.css">
</head>
<body>
  <main class="legal-page">
    <div class="container">
      <h1>Allgemeine Gesch\u00e4ftsbedingungen (AGB)</h1>

      <h2>1. Geltungsbereich</h2>
      <p>Diese Allgemeinen Gesch\u00e4ftsbedingungen (AGB) gelten f\u00fcr alle Gesch\u00e4ftsbeziehungen zwischen ${esc(legal.name || 'dem Anbieter')} (nachfolgend \u00abAnbieter\u00bb) und dem Kunden. Abweichende Bedingungen des Kunden werden nicht anerkannt, es sei denn, der Anbieter stimmt diesen ausdr\u00fccklich schriftlich zu.</p>

      <h2>2. Vertragsschluss</h2>
      <p>Ein Vertrag kommt zustande durch die schriftliche Auftragsbestätigung des Anbieters oder durch Beginn der Leistungserbringung. Angebote des Anbieters sind freibleibend und unverbindlich, sofern nicht ausdr\u00fccklich anders vereinbart.</p>

      <h2>3. Leistungsumfang</h2>
      <p>Der Umfang der Leistungen ergibt sich aus der jeweiligen Auftragsbestätigung oder dem individuellen Vertrag. \u00c4nderungen oder Erweiterungen des Leistungsumfangs bed\u00fcrfen der schriftlichen Vereinbarung.</p>

      <h2>4. Preise und Zahlungsbedingungen</h2>
      <p>Alle Preise verstehen sich in Schweizer Franken (CHF) und zuz\u00fcglich der gesetzlichen Mehrwertsteuer, sofern nicht anders angegeben. Rechnungen sind innert ${esc(zahlungsfrist)} nach Rechnungsdatum ohne Abzug zahlbar.</p>
      <p>Bei Zahlungsverzug ist der Anbieter berechtigt, Verzugszinsen von 5% p.a. zu erheben sowie Mahngebühren in Rechnung zu stellen.</p>

      <h2>5. Mitwirkungspflichten des Kunden</h2>
      <p>Der Kunde stellt dem Anbieter alle zur Leistungserbringung erforderlichen Unterlagen, Informationen und Zugänge rechtzeitig und kostenlos zur Verf\u00fcgung. Verzögerungen aufgrund mangelnder Mitwirkung gehen nicht zu Lasten des Anbieters.</p>

      <h2>6. Geistiges Eigentum</h2>
      <p>Alle Urheberrechte und sonstigen Schutzrechte an den vom Anbieter erstellten Werken verbleiben beim Anbieter, bis die vollst\u00e4ndige Bezahlung erfolgt ist. Nach vollst\u00e4ndiger Bezahlung gehen die vereinbarten Nutzungsrechte auf den Kunden über.</p>

      <h2>7. Gew\u00e4hrleistung und Haftung</h2>
      <p>Der Anbieter erbringt seine Leistungen nach bestem Wissen und Gewissen. Die Haftung für leichte Fahrl\u00e4ssigkeit wird ausgeschlossen, soweit gesetzlich zul\u00e4ssig. Die Haftung ist in jedem Fall auf den Auftragswert beschr\u00e4nkt.</p>
      <p>F\u00fcr indirekte Sch\u00e4den, Folgesch\u00e4den oder entgangenen Gewinn wird keine Haftung \u00fcbernommen.</p>

      <h2>8. Vertraulichkeit</h2>
      <p>Beide Parteien verpflichten sich, vertrauliche Informationen der anderen Partei nicht an Dritte weiterzugeben und nur zum Zweck der Vertragserfüllung zu verwenden. Diese Pflicht besteht auch nach Beendigung des Vertragsverh\u00e4ltnisses.</p>

      <h2>9. K\u00fcndigung</h2>
      <p>Laufende Vertr\u00e4ge k\u00f6nnen von beiden Seiten unter Einhaltung einer Frist von 30 Tagen zum Monatsende gek\u00fcndigt werden, sofern nicht anders vereinbart. Das Recht zur fristlosen K\u00fcndigung aus wichtigem Grund bleibt vorbehalten.</p>

      <h2>10. Anwendbares Recht und Gerichtsstand</h2>
      <p>Es gilt ausschliesslich Schweizer Recht. Gerichtsstand ist ${esc(gerichtsstand)}, Schweiz.</p>

      <p style="margin-top: 2em; color: var(--c-text-muted); font-size: var(--text-sm);">Stand: ${new Date().toLocaleDateString('de-CH', { year: 'numeric', month: 'long' })}</p>

      <p><a href="index.html">\u2190 Zur\u00fcck zur Startseite</a></p>
    </div>
  </main>
  <script src="js/main.js"><${'/'}script>
</body>
</html>`;
}
